

export class LbpaProfile {
    public static readonly CONSEILLER_ADMIN: string = 'conseiller_admin';
}



// WEBPACK FOOTER //
// ./src/app/config/provider/lbpa-profile.constant.ts